import { render, staticRenderFns } from "./AccountRecoveryForm.vue?vue&type=template&id=cf50c6ce"
import script from "./AccountRecoveryForm.vue?vue&type=script&lang=js"
export * from "./AccountRecoveryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports